/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import PermissionsForm from "../../componentes/permissions/permissionsForm";
import ModalPermissions from "../../componentes/permissions/modalPermissions";
import { headers } from "../../componentes/permissions/dataHeaders";
import { getChargesByStatusActive } from "../../actions/charge-actions";
import { getActiveRegionals } from "../../actions/regional-actions";
import {
  createPermissions,
  filterApprovingCharge,
} from "../../actions/permissions-actions";
import { useStateValue } from "../../context/store";
import ModalConfirmBase from "../../utils/form/modalConfirmBase";
import moment from "moment";

const Permissions = (props) => {
  const [charge, setCharge] = useState([]);
  const [regionals, setRegionals] = useState([]);
  const [open, setOpen] = React.useState(false);
  const [dataId, setDataId] = useState("");
  const [{ filterPermissions }, dispatch] = useStateValue();
  const [isMinToHour, setIsMinToHour] = useState(false);
  const [data, setData] = useState({
    firstName: null,
    surname: null,
    chargeId: null,
    regionalId: null,
  })

  const [message, setMessage] = useState({
    description: "",
    textButtonSubmit: "",
    handleClick: () => {},
    handleClickOut: () => {},
    oneButtons: false,
    type: "",
    open: false,
  });

  const [paginadorRequest, setPaginadorRequest] = useState({
    page: 0,
    size: 10,
    order: "DESC",
    columnOrder: "firstName",
  });

  const [paginadorResponse, setPaginadorResponse] = useState({
    data: [],
    totalRows: 0,
    pageSize: 0,
    pageNumber: 0,
  });

  const changePage = (event, nuevaPagina) => {
    setPaginadorRequest((anterior) => ({
      ...anterior,
      page: parseInt(nuevaPagina),
    }));
  };

  const changeAmountOfRecords = (event) => {
    setPaginadorRequest((anterior) => ({
      ...anterior,
      size: parseInt(event.target.value),
      page: 0,
    }));
  };

  const handleOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  useEffect(() => {
    const getCharge = async () => {
      const response = await getChargesByStatusActive();
      setCharge(response?.data?.chargeList);
    };
    getCharge();
  }, []);

  useEffect(() => {
    const getRegional = async () => {
      const response = await getActiveRegionals();
      setRegionals(response?.data?.regionalList);
    };
    getRegional();
  }, []);

  const getRequest = async () => {
    const response = await filterApprovingCharge(
      {
        firstName: data.firstName === "" ? null : data.firstName,
        surname: data.surname === "" ? null : data.surname,
        chargeId: data.chargeId === "" ? null : data.chargeId,
        regionalId: data.regionalId === "" ? null : data.regionalId,
      },
      {
        page: paginadorRequest.page,
        size: paginadorRequest.size,
        order: paginadorRequest.order,
        columnOrder: paginadorRequest.columnOrder,
      },
      dispatch
    );
    if (response && (response?.status === 200 || response?.status === 201)) {
      const resp = response?.data?.employeesPagePage;
      if (response?.data?.employeesPagePage?.content.length > 0) {
        setPaginadorResponse({
          data: resp?.content,
          totalRows: resp?.totalElements,
          pageSize: resp?.size,
          pageNumber: resp?.number,
        });
      } else {
        setPaginadorResponse({
          data: [],
          totalRows: 0,
          pageSize: 0,
          pageNumber: 0,
        });
      }
    }
  };

  useEffect(() => {
    getRequest();
  }, [paginadorRequest]);

  if (
    filterPermissions &&
    filterPermissions?.isFilter &&
    data !== filterPermissions.filter
  ) {
    const newFilter = filterPermissions.filter;
    data.firstName = newFilter.firstName;
    data.surname = newFilter.surname;
    data.chargeId = newFilter.chargeId;
    data.regionalId = newFilter.regionalId;
    paginadorRequest.page = 0;
    getRequest();
    dispatch({
      type: "SET_PERMISSIONS_FILTER",
      isFilter: false,
    });
  }

  const handleClickClose = () => {
    setMessage({ ...message, open: false });
  };

  const handleClickCloseRedirect = () => {
    setMessage({ ...message, open: false });
    props.history.push(`/dashboard/permissionsSearch/c3ee84b698ab7c8b1c8161180fc644c3cad1cd9b`);
  };

  const returnMessageError = (messag) => {
    setMessage({
      description: messag,
      textButtonSubmit: "ACEPTAR",
      handleClick: () => handleClickClose(),
      oneButtons: true,
      type: "WARNING",
      open: true,
    });
  }

  function GetDuration(start, end) {
    const duration = moment.duration(moment(end).diff(moment(start)));

    const days = Math.floor(duration.asDays());

    if (days > 0) {
      return { "Days": days };
    }

    const hours = duration.hours();
    if (hours > 0) {
      return { "Hours": hours} ;
    }

    if(days <= 0 && hours <= 0){
      return {"zero": 0}
    }

  }

  const onSubmit = (data) => {
    if (!dataId) {
      setMessage({
        description: `Debe seleccionar un usuario aprobador`,
        textButtonSubmit: "Aceptar",
        handleClick: () => handleClickClose(),
        oneButtons: true,
        type: "WARNING",
        open: true,
      });
      return;
    }

    const dateOne = new Date(data.initDate);
    const dateTwo = new Date(data.endDate);
    const durationObj = GetDuration(dateOne,dateTwo);
    if(durationObj?.hasOwnProperty('zero')){
      setIsMinToHour(true);
      return;
    }else{
      setIsMinToHour(false);
      objByPermission(data, durationObj);
    }
  };

  const objByPermission = (data, durationObj) => {
    const newData = {
      paid: data.remuner === "Remunerado" ? true : false,
      permitStarDate: moment(data.initDate).format("YYYY-MM-DD HH:mm:00"),
      permitEndDate: moment(data.endDate).format("YYYY-MM-DD HH:mm:00"),
      numberDay: durationObj?.hasOwnProperty('Days') ? durationObj.Days : 0,
      permitDurationHour: durationObj?.hasOwnProperty('Hours') ? durationObj.Hours : 0,
      permissionType: data.typePermission,
      permissionTypeOtherDescription: data.description,
      observation: data.observations,
      approvingEmployeeId: dataId,
    };
    setMessage({
      description: "¿Está seguro de generar el permiso? ",
      textButtonSubmit: "Guardar",
      handleClick: () => handleClick(newData),
      handleClickOut: () => handleClickClose(),
      type: "QUESTION",
      open: true,
    });
  }

  const handleClick = async (data) => {
    setMessage({ ...message, open: false });
    const request = await createPermissions(data);
    if (request && (request?.status === 200 || request?.status === 201)) {
      setMessage({
        description: `Su permiso ha sido generado de manera exitosa`,
        textButtonSubmit: "Aceptar",
        handleClick: () => handleClickCloseRedirect(),
        oneButtons: true,
        type: "SUCCESS",
        open: true,
      });
      setDataId("");
    } else if (
      request?.status > 399 &&
      request?.status !== 401 &&
      request?.sattus !== 403
    ) {
      setMessage({
        description: request?.data?.detail
          ? request?.data?.detail
          : `El permiso no ha sido enviado, inténtelo nuevamente`,
        textButtonSubmit: "Aceptar",
        handleClick: () => handleClickClose(),
        oneButtons: true,
        type: "WARNING",
        open: true,
      });
    } else {
      returnMessageError('Ocurrió un error procesando la solicitud, inténtelo nuevamente');
    }
  };

  return (
    <div>
      <PermissionsForm
        handleOpen={handleOpen}
        onSubmit={onSubmit}
        isMinToHour={isMinToHour}
        GetDuration={GetDuration}
        setIsMinToHour={setIsMinToHour}
      />

      <ModalPermissions
        headers={headers}
        charge={charge}
        regionals={regionals}
        handleClose={handleClose}
        open={open}
        setOpen={setOpen}
        paginadorResponse={paginadorResponse}
        paginadorRequest={paginadorRequest}
        changePage={changePage}
        changeAmountOfRecords={changeAmountOfRecords}
        setDataId={setDataId}
        dataId={dataId}
      />

      <ModalConfirmBase
        description={message.description}
        textButtonSubmit={message.textButtonSubmit}
        handleClick={message.handleClick}
        handleClickOut={message.handleClickOut}
        oneButtons={message.oneButtons}
        type={message.type}
        open={message.open}
      />
    </div>
  );
};

export default Permissions;
